var _path, _mask, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPpt = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6667 5.30397L23.656 10.6666H19.6187C19.0934 10.6666 18.6667 10.1586 18.6667 9.5333V5.30397ZM26.3214 9.77063L20.3947 3.10396C20.1427 2.82529 19.784 2.66663 19.408 2.66663H8.74137C6.86137 2.66663 5.33337 4.16263 5.33337 5.99996V26C5.33337 27.8373 6.86137 29.3333 8.74137 29.3333H23.2587C25.1387 29.3333 26.6667 27.8373 26.6667 26V10.6666C26.6667 10.3346 26.544 10.016 26.3214 9.77063V9.77063Z",
    fill: "#F15642"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 22,
    height: 28
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6667 5.30397L23.656 10.6666H19.6187C19.0934 10.6666 18.6667 10.1586 18.6667 9.5333V5.30397ZM26.3214 9.77063L20.3947 3.10396C20.1427 2.82529 19.784 2.66663 19.408 2.66663H8.74137C6.86137 2.66663 5.33337 4.16263 5.33337 5.99996V26C5.33337 27.8373 6.86137 29.3333 8.74137 29.3333H23.2587C25.1387 29.3333 26.6667 27.8373 26.6667 26V10.6666C26.6667 10.3346 26.544 10.016 26.3214 9.77063V9.77063Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.5091C9 17.2656 9.19182 17 9.50076 17H11.2041C12.1632 17 13.0263 17.6419 13.0263 18.8721C13.0263 20.0377 12.1632 20.687 11.2041 20.687H9.97293V21.6608C9.97293 21.9854 9.76727 22.169 9.50168 22.169C9.25822 22.169 9.00092 21.9854 9.00092 21.6608V17.5091H9V17.5091ZM9.97293 17.9287V19.7657H11.2041C11.6984 19.7657 12.0894 19.3295 12.0894 18.8721C12.0894 18.3566 11.6984 17.9287 11.2041 17.9287H9.97293Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9661 17.5091C13.9661 17.2656 14.1579 17 14.4677 17H16.1711C17.1302 17 17.9933 17.6419 17.9933 18.8721C17.9933 20.0377 17.1302 20.687 16.1711 20.687H14.9399V21.6608C14.9399 21.9854 14.7333 22.169 14.4677 22.169C14.2243 22.169 13.9661 21.9854 13.9661 21.6608V17.5091V17.5091ZM14.939 17.9287V19.7657H16.1701C16.6644 19.7657 17.0555 19.3295 17.0555 18.8721C17.0555 18.3566 16.6644 17.9287 16.1701 17.9287H14.939Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3099 17.9886H19.0207C18.3788 17.9886 18.3788 17.0452 19.0207 17.0452H22.5076C23.1642 17.0452 23.1642 17.9886 22.5076 17.9886H21.2838V21.7124C21.2838 22.3534 20.3099 22.3691 20.3099 21.7124V17.9886Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPpt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ppt.7bae6108.svg";
export { ForwardRef as ReactComponent };